import { useLingui } from '@lingui/react/macro';
import type { FC } from 'react';
import { cn } from '@/shared/react';
import { useMyTradeFees } from './api';

/**
 * The class the requester is on. `fee_class` is null on the global rates or for
 * a house account — there is no class to name, so this renders nothing.
 */
export const CurrentFeeClass: FC<{ className?: string }> = ({ className }) => {
  const { t } = useLingui();
  const myFees = useMyTradeFees();
  const feeClass = myFees.data?.fee_class;

  if (!feeClass) return null;

  return (
    <p className={cn('text-sm text-content-tertiary', className)}>
      {t`You're on`}{' '}
      <span className="text-content-primary font-medium">{feeClass.name}</span>
      {feeClass.description ? ` — ${feeClass.description}` : ''}
    </p>
  );
};
